// extracted by mini-css-extract-plugin
module.exports = {"tabNav":"Tab_tabNav__QYjsQ","tabLink":"Tab_tabLink__8WFZF","tabLinkContainer":"Tab_tabLinkContainer__G_nCy","dividerRight":"Tab_dividerRight__4Z9S0"};